module.exports = __webpack_public_path__ + "img/Equatorial Guinea.79e8fd3c.svg";